import script from "./CanteenProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./CanteenProducts.vue?vue&type=script&setup=true&lang=js"

import "./CanteenProducts.vue?vue&type=style&index=0&id=5989428a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5989428a"]])

export default __exports__